module.exports = __webpack_public_path__ + "img/report-9.0a1d7b1a.jpg";